export default __webpack_public_path__ + "static/media/Square_Ad.505e5dd7.gif";